import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";
import AIChat from "@/components/AIChat";
import { PageHeader } from "@/components/ui-helpers";

export default function AISecretaryPage({ surface = "customer" }) {
  const [sp] = useSearchParams();
  const q = sp.get("q");
  const fallback = surface === "agent"
    ? ["Find the best flight for my customer", "Show my pending enquiries", "Create a Dubai quotation", "Show today's business report", "Prepare a WhatsApp quotation"]
    : ["Show my upcoming bookings", "What am I waiting for?", "Which orders are arriving?", "What bills are due?", "What expires soon?"];
  const [suggestions, setSuggestions] = useState(fallback);
  useEffect(() => {
    api.get("/ai/suggest").then((r) => { if (r.data.suggestions?.length) setSuggestions(r.data.suggestions); }).catch(() => {});
  }, []);
  return (
    <div className="mx-auto max-w-3xl">
      <PageHeader title="AI Secretary" subtitle="One Universal AI Secretary across your entire Suffle workspace." icon={Sparkles} />
      <div className="card-soft h-[calc(100vh-230px)] min-h-[440px] p-5">
        <AIChat key={q || "ai"} surface={surface} suggestions={suggestions} />
      </div>
    </div>
  );
}
